// extracted by mini-css-extract-plugin
module.exports = {"url":"_2jEMuyM-CecC5hjxEQPkUY","thumb":"_2G5feDIx_-pJ-FyWnMn3Df","newsStat":"_2gY89IIT-Bv4fpK6C61_w3"};